<div class="fs-gallery-root">
  <post-text [text]="data.text" [expanded]="data.expanded"></post-text>
  <div #viewport class="gallery-wrapper" [class.nonscrollable]="isNonScrollable()" [class.interacting]="isInteracting || slotTransition !== 'none'" [class.pseudo-fullscreen]="isPseudoFullscreen" (wheel)="onMouseWheel($event)">
    <ng-container *ngIf="data.items.length > 1">
      <div #prevSlot class="item-wrapper non-selectable" [style.transform]="prevTransform" [style.transition]="slotTransition" [style.opacity]="slotOpacityPrev">
          <img [src]="prevSrc" decoding="async" [alt]="data.items[activeIndex].title || 'photo'" />
      </div>
    </ng-container>
    <ng-container *ngIf="data.items.length">
      <div #activeSlot class="item-wrapper non-selectable" [style.transform]="activeTransform" [style.transition]="slotTransition" [style.opacity]="slotOpacityActive" (transitionend)="onTransitionEnd($event)">
        <ng-container [ngSwitch]="images[activeIndex].type">
          <img *ngSwitchDefault [src]="activeSrc" decoding="async" [alt]="data.items[activeIndex].title || 'photo'" />
          <video *ngSwitchCase="'video'" [src]="data.items[activeIndex].src" controls></video>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="data.items.length > 1">
      <div #nextSlot class="item-wrapper non-selectable" [style.transform]="nextTransform" [style.transition]="slotTransition" [style.opacity]="slotOpacityNext" style="z-index: 1; pointer-events: none">
          <img [src]="nextSrc" decoding="async" [alt]="data.items[activeIndex].title || 'photo'" />
      </div>
    </ng-container>

    <ng-container>
      <!-- Desktop controls: class='hideonsmall' are hidden on small displays -->
      <div class="controls wrapper non-selectable" (click)="$event.stopPropagation();" (pointerdown)="$event.stopPropagation();" (pointermove)="$event.stopPropagation()" (pointerup)="$event.stopPropagation()" (pointercancel)="$event.stopPropagation()" (wheel)="$event.stopPropagation()">
        <div class="horiz">
          <button (click)="slideToPrev()" [title]="'ctl.prev' | translate">◀</button>
          <button (click)="slideToNext()" [title]="'ctl.next' | translate">▶</button>
          <button (click)="toggleSlideshow()" [class]="(isPlaying ? 'pi pi-pause-circle' : 'pi pi-play-circle')" [title]="'ctl.play-pause' | translate"></button>
          <button (click)="toggleFullscreen()"[class]="(isFullscreen ? 'pi pi-times' : 'pi pi-arrow-up-right-and-arrow-down-left-from-center')" [title]="(isFullscreen ? 'ctl.fullscreen-off' : 'ctl.fullscreen') | translate"></button>
        </div>
        <div class="vert">
          <button class="pi pi-search-plus hideonsmall" (click)="zoomIn()" [title]="'ctl.zoom-in' | translate"></button>
          <button class="pi pi-search-minus hideonsmall" (click)="zoomOut()" [title]="'ctl.zoom-out' | translate"></button>
          <div *ngIf="rotationCompassVisible">
            <button class="pi pi-compass btn-icon" type="button" (click)="clickRotationCompass()" [title]="'ctl.rotation' | translate">
              <span class="btn-icon-overlay" [style.transform]="slotRotationCompass">
                <i class="icon pi pi-compass"></i>
                <i class="icon overlay pi pi-angle-up"></i>
              </span>
            </button>
          </div>
          <button class="pi pi-list" *ngIf="isDevMode" (click)="toggleDevLog()" title="Debug-log" style="background-color: blueviolet;"></button>
          <button class="pi pi-trash" *ngIf="isDevMode" (click)="clearDevLog()" title="Cleaer Debug-log" style="background-color: blueviolet;"></button>
        </div>
      </div>
      <div class="gallery-footer" *ngIf="showTitle" (click)="$event.stopPropagation();" (pointerdown)="$event.stopPropagation();" (pointermove)="$event.stopPropagation()" (pointerup)="$event.stopPropagation()" (pointercancel)="$event.stopPropagation()" (wheel)="$event.stopPropagation()">
        <button type="button" pButton icon="pi pi-list" (click)="onThumbnailButtonClick()" class="thumbnail-button"></button>
        <div *ngIf="data.items" class="title-container">
          <div class="gallery-footer-no">{{ activeIndex + 1 }}/{{ data.items.length }}</div>
          <div>
            <div *ngIf="mediaLabel" class="gallery-footer-title"><b>{{ mediaLabel.title }}</b>{{ mediaLabel.desc }}</div>
          </div>
        </div>
      </div>
      <div class="loading-overlay">
        <div class="loading-items">
          <ng-container *ngFor="let task of localDownloads">
            <div class="task" *ngIf="task.isVisible" [style.opacity]="task.isActive ? 1 : 0" [style.scale]="task.isActive ? 1 : 0.5">
              <progress-kolecko
                class="loading-spinner"
                [class.error]="task.isError"
                [strokeWidth]="12"
                [progress]="task.progress"
                [showLabel]="task.progress >= 0">
              </progress-kolecko>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="debug-logger" *ngIf="showDevLog">
        <div class="bar">
          <span style="color:white; background-color: #800080c0;">TCH: {{ capitalizeFirst(touchState) }}<br>TRN: {{ capitalizeFirst(transitionState) }}</span>
          <span style="color:white; background-color: #a04000c0; white-space: pre-wrap;">POS: {{ dbgGesture }}</span>
        </div>
        <div class="log">
          <div *ngFor="let logLine of getLogLines()" [style.background-color]="logLineColor(logLine)">
            <ng-container *ngIf="logLine.prefix">
              <span>{{ logLine.time }} {{ logLine.msg }}</span>
            </ng-container>
          </div>
        </div>
      </div>      
    </ng-container>
    <div #koleckoSlot class="crossmark" [style.display]="koleckoVisible ? null : 'none'" [style.transform]="slotKoleckoCoords" [style.opacity]="koleckoVisibleSolid ? 1 : 0" [style.transition]="slotKoleckoTransition">
      <progress-kolecko class="kolecko" [strokeWidth]="20" [progress]="50"></progress-kolecko>
    </div>    
  </div>
</div>
